import { render, staticRenderFns } from "./CheckCommission.vue?vue&type=template&id=53b6d2c6&scoped=true"
import script from "./CheckCommission.vue?vue&type=script&lang=js"
export * from "./CheckCommission.vue?vue&type=script&lang=js"
import style0 from "./CheckCommission.vue?vue&type=style&index=0&id=53b6d2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b6d2c6",
  null
  
)

export default component.exports